import React, { useEffect, useState } from 'react';
import { Table, Button, Space, Popconfirm, message, Typography, Modal, Form, Input } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { useGetTagsMutation, useCreateTagMutation, useDeleteTagMutation } from '../redux/services/apiSlice';

const { Title } = Typography;

const CommonTags = () => {
    const [getTags, { data: tags, isLoading }] = useGetTagsMutation();
    const [createTag] = useCreateTagMutation();
    const [deleteTag] = useDeleteTagMutation();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [form] = Form.useForm();

    useEffect(() => {
        getTags();
    }, [getTags]);

    const handleCreate = async (values) => {
        try {
            await createTag(values).unwrap();
            message.success('Tag created');
            setIsModalVisible(false);
            form.resetFields();
            getTags();
        } catch (error) {
            message.error(error.data?.message || 'Error creating tag');
        }
    };

    const handleDelete = async (id) => {
        try {
            await deleteTag(id).unwrap();
            message.success('Tag deleted');
            getTags();
        } catch (error) {
            message.error(error.data?.message || 'Error deleting');
        }
    };

    const columns = [
        { title: 'Tag Name', dataIndex: 'tagName', key: 'tagName' },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <Popconfirm title="Are you sure?" onConfirm={() => handleDelete(record._id)}>
                    <Button type="primary" danger icon={<DeleteOutlined />} size="small" />
                </Popconfirm>
            ),
        }
    ];

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 20 }}>
                <Title level={2}>Common Tags Management</Title>
                <Button type="primary" icon={<PlusOutlined />} onClick={() => setIsModalVisible(true)}>Add New Tag</Button>
            </div>
            <Table dataSource={tags} columns={columns} rowKey="_id" loading={isLoading} />
            <Modal title="Add New Tag" open={isModalVisible} onCancel={() => setIsModalVisible(false)} onOk={() => form.submit()} icon={<PlusOutlined />}>
                <Form form={form} onFinish={handleCreate} layout="vertical">
                    <Form.Item name="tagName" label="Tag Name" rules={[{ required: true }]}>
                        <Input placeholder="e.g. Adventure, Relaxing" />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default CommonTags;
